import { useMarketRoute } from '../../../hooks/useMarketRoute';

export const useMarketSno = () => {
  const { params } = useMarketRoute<'MarketHome'>();
  return params.marketId;
};
